export const ADD_NEW_TAG = 'Add new tag';

export const normalizeTags = (value) => {
  if (Array.isArray(value)) return value;
  if (!value) return [];

  try {
    const parsedValue = JSON.parse(value);
    return Array.isArray(parsedValue) ? parsedValue : [];
  } catch (e) {
    return String(value)
      .split(',')
      .map((tag) => tag.trim())
      .filter((tag) => tag !== '');
  }
};

export const getTagsFromContacts = (contacts = []) => {
  const tags = [];

  contacts.forEach((contact) => {
    const contactTags = normalizeTags(contact?.tags);

    if (contactTags.length > 0) {
      contactTags.forEach((tag) => {
        if (tag && tags.filter((item) => item === tag).length === 0) {
          tags.push(tag);
        }
      });
    }
  });

  return tags;
};

export const buildTagOptions = (taglist = [], selectedTagList = []) => {
  const options = [
    { label: ADD_NEW_TAG, value: ADD_NEW_TAG, key: ADD_NEW_TAG },
  ];

  [...normalizeTags(taglist), ...normalizeTags(selectedTagList)].forEach(
    (tag) => {
      if (
        tag &&
        options.filter((option) => option.value === tag).length === 0
      ) {
        options.push({ label: tag, value: tag, key: tag });
      }
    }
  );

  return options;
};